import { Component } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-confirm-card-removing-dialog',
  templateUrl: './confirm-card-removing-dialog.component.html',
  styleUrl: './confirm-card-removing-dialog.component.scss'
})
export class ConfirmCardRemovingDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<ConfirmCardRemovingDialogComponent>,
  ) {
  }

  closeDialog(isCardRemoved: boolean): void {
    this.dialogRef.close(isCardRemoved);
  }
}
